export default {
  source: 'osm',
  'source-layer': 'roads',
  type: 'line',
  filter: ['all', ['==', '$type', 'LineString']],
  layout: {
    'line-cap': 'round',
    'line-join': 'round',
  },
}
